import {Row, Col, message} from 'antd';
import { useHistory } from 'react-router-dom';
import CaseCard from '../CaseCard';
import BaseTitle from '../BaseTitle';
import EmptyData from '../EmptyData';
import s from './index.module.css';
import {useEffect, useState} from "react";
import {getAchievement, getExpert} from "../../server/api";

const CaseSection = ({ selectedModule }) => {
  const history = useHistory();
  const [achievement, setAchievement] = useState([]);

  useEffect(() => {
    if (selectedModule && selectedModule.code) {
      requestAchievement();
    }
  }, [selectedModule])

  const requestAchievement = async () => {
    let params = {
      pageSize: 4,
      pageNo: 1,
      category: selectedModule.code
    };
    getAchievement(params)
        .then(function (res) {
          const { status, data: { result } } = res;
          if (status === 200) {
            setAchievement(result.records);
            return;
          }
          message.error('查询数据出错，请刷新重试！');
        })
        .catch(function (error) {
        });
  }




  const caseData = [
    {
      id: 1,
      title: '庆阳市质量中心主体结构检测项目',
      image: '/logo01.png', // 使用public目录下的图片
      category: '质量工程检测',
      date: '2024年6月',
      views: '2024浏览',
      description: '对庆阳市质量中心主体结构进行了全面质量检测，确保工程质量符合国家相关标准要求...'
    },
    {
      id: 2,
      title: '庆阳市体育中心主体结构检测项目',
      image: '/logo01.png',
      category: '建筑工程检测',
      date: '2024年6月',
      views: '2024浏览',
      description: '对庆阳市体育中心主体结构进行了全面质量检测，确保建筑工程质量符合标准...'
    },
    {
      id: 3,
      title: '庆阳市质量中心主体结构检测项目',
      image: '/logo01.png',
      category: '质量工程检测',
      date: '2024年6月',
      views: '2024浏览',
      description: '对庆阳市质量中心主体结构进行了全面质量检测，确保工程质量符合国家相关标准要求...'
    },
    {
      id: 4,
      title: '庆阳市体育中心主体结构检测项目',
      image: '/logo01.png',
      category: '建筑工程检测',
      date: '2024年6月',
      views: '2024浏览',
      description: '对庆阳市体育中心主体结构进行了全面质量检测，确保建筑工程质量符合标准...'
    }
  ];

  const handleCaseClick = (caseItem) => {
    history.push(`/cases/${caseItem.id}`);
  };

  const handleViewMore = () => {
    history.push('/cases');
  };

  return (
    <div className={s.caseSection}>
      <BaseTitle
        title="优秀案例"
        subtitle="精选优质检测项目案例，展示专业技术实力"
      />

      <Row gutter={[24, 24]} className={s.caseCards}>
        {achievement && achievement.length > 0 ? (
          achievement.map((item) => (
            <Col xs={24} sm={12} md={12} lg={6} key={item.id}>
              <CaseCard
                caseData={item}
                onClick={handleCaseClick}
              />
            </Col>
          ))
        ) : (
          <Col span={24}>
            <EmptyData description="暂无案例数据" />
          </Col>
        )}
      </Row>

      {achievement && achievement.length > 0 && (
        <div className={s.caseMore}>
          <a href="#" className={s.moreLink} onClick={(e) => { e.preventDefault(); handleViewMore(); }}>查看更多</a>
        </div>
      )}
    </div>
  );
};

export default CaseSection;
